import React from 'react'
import '../css/OrderReview.css';
// import ProjectArea from '../images/Overview/Project Area.gif';

export default function OrderReview() {
  return (
    <div className='outerBox'>
        <div className="innerBox">
        <h3> Order Review</h3>
         Your property is being upgraded
        <div className="box1">
            <div className="box1_2">
            {/* <img src={ProjectArea}></img> */}
            </div>
            <div className='box1_3'>
            <span><b>You have no active sell listing currently</b></span><br/>
            <span>Benefits will start once a resale listing is active</span><br/><br/>
            <span className="box1_1">Upload Listing Now</span> or upload later
            </div>
            
        </div>
        <div className="box2">
            <div className='box_2_1'>Selected Package   
            <span>Valid till 24 Apr 2025</span>
            </div>
            <div className='dg'><b>Sell - Premium +</b></div>
            <hr/>
            <div className="lt">
                <list>
                    <li>Visible to 86% buyers</li>
                    <li>Validity - 120 days</li>
                    <li>Medium Slot</li>
                    <li>Upto 20 Matching Buyer Contacts</li>
                    <li>Professional Photoshoot of Property <div className="box_2_2"><span ><b>₹7499</b></span></div></li>
                </list>
            </div> 
        </div>
        <div className='box3'>
            I agree to the <span className="box3_1">privacy policy</span> and <span className="box3_1">terms</span>.
            Plans not applicable for Commercial and PG listings.
        </div>
        </div>
        <div className="sidebox">
        <div className='box4'>
            <div className="box4_1">
           <label htmlFor='drop-down'>Billing City</label> 
           <select></select>
           </div><hr/>
           <div className="box4_1">
            <label>Offers</label>
            <select></select>
            </div><hr/>
            </div>
        <div className='box5'>
            <div className='box5_1'> Price <span>₹7499</span> </div>
            <div className='box5_1'> Add-on discount <span className='box5_2'>-₹374</span></div>
            <div className='box5_1'> Sub-total <span>₹7125 </span></div>
            <div className='box5_1'> Tax (GST 18%) <span>₹1282</span> </div>
            <hr/>
            <div className='box5_1'> Total Payable <span><b>₹8407</b></span></div>
            <button><b>Confirm and Pay ₹8407</b></button>
        </div>
        <div className='box6'>
            Your total savings on this product are <b>₹374</b>
        </div>
        </div> 
    </div>

  )
}
